import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs'

import { environment } from './../../../environments/environment'

import { applyTranslations } from '../../core/helpers/translations'
import { makeUrlSafe } from '../../core/helpers/url-ready'

import { Facet } from '../../facets/models/facet'
import { FacetGroup } from '../../facets/models/facet-group'
import { FacetCount } from '../../facets/models/facet-count'
import { AppliedFacets } from '../../facets/models/applied-facets'
import { parseFacets } from '../../facets/helpers/facet-parser'
import { ResponseWrap } from '../../core/models/response-wrap';
import { FilterItem } from '../../shared/models/filter';

const facetGroupApiUrl = '/facetgroups'
const facetBaselineUrl = '/facets'
const facetsProductCountUrl = '/facetproductcount'

@Injectable()
export class FacetService {

  constructor(private http: HttpClient) { }

    /** Retrieve all applicable facetgroups */
    getFacetGroups(): Observable<FacetGroup[]> {

        return this.http.get<ResponseWrap<FacetGroup>>(
            environment.baseApiUrl + facetGroupApiUrl
        ).pipe(
        map(res => res.results),
        map(makeUrlSafe('code')),
        map(applyTranslations))
    }

    /** Retrieve the facet baseline with translations. */
    getFacetBaseline(customerId: string): Observable<Facet[]> {
      let params = new HttpParams().set('customerId', customerId)

      return this.http.get<ResponseWrap<Facet>>(
            environment.baseApiUrl + facetBaselineUrl,
          {
            params
          }
        ).pipe(
        map(res => res.results),
        map(makeUrlSafe('name', 'url_code')),
        map(applyTranslations))
    }

    /** Retrieve all facets for specified hierarchy position */
    getFacetCount(
      pageId: string,
      customerId: string,
      applied?: AppliedFacets,
      additionalParams?: string,
      onlyInStock?: boolean,
      searchTerm?: string,
      filterItems?: FilterItem[]
    ): Observable<FacetCount[]>
    {
      let url = `${environment.baseApiUrl}${facetsProductCountUrl}`

      let params = applied
        ? parseFacets(applied).set('customerId', customerId).set('pageId', pageId).set('inStockOnly', '0')
        : new HttpParams().set('customerId', customerId).set('pageId', pageId).set('inStockOnly', '0')

      if (filterItems && filterItems.length) {
        filterItems.forEach((filterItem) => {
          if (params.has('filter')) {
            params = params.append('filter', filterItem.code)
          } else {
            params = params.set('filter', filterItem.code)
          }
        })
      }

      if (additionalParams) {
        const parsedParams = additionalParams.split('=')
        params = params.set(parsedParams[0], parsedParams[1])
      }

      if(onlyInStock)
        params = params.set('inStockOnly', '1')

      if (searchTerm) {
        const encodedSearchParam = encodeURIComponent(searchTerm)
        url = `${url}?search=${encodedSearchParam}`
      }

      return this.http.get<ResponseWrap<FacetCount>>(
        url,
        {
          params
        }
      ).pipe(
        map(res => res.results))
    }
}
